export function _unique<T>(array: T[]) {
    return Array.from(new Set(array));
}

// Date formatting utilities
export {
    formatDate,
    formatDateChart,
    formatDateCompact,
    formatDateISO,
    formatDateTime,
    formatDateTimeFull,
    formatIngestionDate,
    formatIngestionDateCompact,
    formatISODate,
    formatRelativeTime,
    formatTime,
    formatValueIfDate,
    isDateColumn,
    isISODateString,
    isValidDate,
    parseDate,
    parseIngestionTimestamp,
} from './src/date';

// String normalization utilities
export { sleep } from './src/sleep';
export { toAlphabetTitleCase } from './src/string';

